import axios from 'axios'

/**
 * Get list of available time slots for scheduling
 *
 * @param {String} token
 * @param {Date} fromDate
 * @param {Date} toDate
 */
export const queryAvailableSlots = ({ token, fromDate, toDate }, cancelToken) => {
  const queryString = new URLSearchParams({
    token,
    from_date: fromDate.toISOString(),
    to_date: toDate.toISOString()
  })

  return axios.get(`/api/v1/schedule/slots?${queryString}`, { cancelToken })
}

/**
 * Overwrite time slots for scheduling
 *
 * @param fromDate
 * @param toDate
 * @param slots
 * @returns {AxiosPromise<any>}
 */
export const overrideAvailableSlots = ({ fromDate, toDate, slots, groupID = null }) => {
  const group = groupID ? { assessment_group: groupID } : {}

  return axios.post('/api/v1/schedule', { start_date: fromDate, end_date: toDate, slots, ...group })
}
